import { hasEditAccess } from '../../../utils';

export const editAccess = (children: any) => {
  if (hasEditAccess()) {
    return children;
  }

  return null;
};
